PJQ.views.projects.dashboard = {};

PJQ.views.projects.ProjectDashboard = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Dashboard')
    },
    events: {
        'click .btn-alert-order-prints': 'orderPrints',
        'click .stack-takeoff': 'stackTakeoff',
        'click .square-takeoff': 'squareTakeoff',
        'click .e-takeoff': 'eTakeoff',
        'click .btn-update-my-info': 'updateMyInfo',
        'click .btn-submit-bid': 'submitBidMessage',
        'click .btn-feature-settings': 'viewFeatureSettings'
    },
    beforeFirstRender: function () {
        if (this.model == null) {
            this.model = PJQ.app.session.project;
        }

        if (this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES_COUNT)) {
            this.model.fetchBidPackages(_.bind(function (bp) {
                this.bidPackages = bp;
                this.render();
            }, this));
        }
    },
    renderData: function () {
        return {
            model: this.model,
            isAdmin: (PJQ.app.session.get('masterUserId') === this.model.get('masterUserId')),
            showBidPackages: this.showBidPackages()
        };
    },
    showBidPackages: function () {
        return this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES_COUNT)
            && this.bidPackages != null
            && _.size(_.filter(this.bidPackages.models, function (bidPackage) {
                let n = bidPackage.get('notes');
                return n != null && _.size(n.trim()) > 0;
            })) > 0;
    },
    afterRender: function () {
        if (this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES_COUNT)) {
            if (this.bidPackages == null) {
                return;
            }
        }
        let showBidPackages = this.showBidPackages(),
            device = PJQ.helpers.mobile.getDevice();
        if (device != null) {
            new PJQ.views.mobile.AppDownloadModal();
        }

        if (showBidPackages) {
            this.renderBidPackages();
        }

        this.model.fetchUserMessageTypes(_.bind(function () {
            if ((PJQ.app.session.get('masterUserId') === this.model.get('masterUserId'))) {
                new PJQ.views.projects.dashboard.ProjectStats({
                    el: this.$('.project-stats'),
                    project: this.model,
                    dashboard: this,
                    emptyCallback: _.bind(function () {
                        this.$('.project-stats-row').remove();
                    }, this)
                });

				new PJQ.views.projects.dashboard.Newsfeed({
					el: this.$('.project-newsfeed'),
					project: this.model,
					dashboard: this
				});
			}
			else {
				// sub command buttons
				this.inviteHeader = new PJQ.views.projects.dashboard.ProjectInviteHeader({
					el: this.$('.project-invite-header'),
					project: this.model,
					dashboard: this,
					afterRender: _.bind(function () {
						if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'project', 'inviteHeader')) {
							let cb = PJQ.app.portal.customization.project.inviteHeader.afterRender;
							if (typeof cb === 'function') {
								cb();
							}
						}

                        if (PJQ.app.session.get('submitBid')) {
                            this.submitBidMessage();
                        }
                    }, this)
                });

                new PJQ.views.projects.dashboard.ProjectDetails({
                    el: this.$('.project-details'),
                    model: this.model,
                    afterRender: function () {
                        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'project', 'details')) {
                            let cb = PJQ.app.portal.customization.project.details.afterRender;
                            if (typeof cb === 'function') {
                                cb();
                            }
                        }
                    }
                });

                if (this.model.user != null) {
                    new PJQ.views.projects.dashboard.ProjectContactDetails({
                        el: this.$('.project-contact-details'),
                        model: this.model.user,
                        project: this.model
                    });
                }

                if (PJQ.app.session.contact != null) {
                    new PJQ.views.projects.dashboard.ProjectMessagesSub({
                        el: this.$('.project-messages-sub'),
                        project: this.model,
                        dashboard: this
                    });
                }
            }

            if (PJQ.app.session.get('masterUserId') !== this.model.get('masterUserId')
                || this.model.hasPermission('attachments.canView')) {
                this.$('.col-attachments').removeClass('hidden');
                new PJQ.views.projects.ProjectAttachments({
                    el: this.$('.project-attachments'),
                    project: this.model,
                    isHideEmptyFolders: true
                });
            }
        }, this));
    },
    renderBidPackages: function () {
        if (this.bidPackages != null) {
            new PJQ.views.projects.dashboard.BidPackages({
                el: this.$('.bid-packages'),
                collection: this.bidPackages
            });
        }
    },
    orderPrints: function () {
        new PJQ.views.files.OrderPrintsModal({
            contact: PJQ.app.session.contact
        });
    },
    updateMyInfo: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectContacts.ProjectContact({
                id: PJQ.app.session.contact.id,
                projectId: this.model.id
            })
        });
    },
    viewFeatureSettings: function() {
        new PJQ.views.featureSettings.FeatureSettingsModal({
            model: new PJQ.models.featureSettings.FeatureSetting(PJQ.app.session.project.get('featureSettings'), {project: PJQ.app.session.project}),
            project: PJQ.app.session.project
        });
    },
    stackTakeoff: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.model.id
            },
            {
                endpoint: 'contacts',
                value: PJQ.app.session.contact.id
            },
            {
                endpoint: 'stackurl'
            }
        ]);
        let request = new PJQ.ajax.Request({
            endpoint: endpoint
        });
        request.get().done(_.bind(function (data) {
            window.location.href = data;
        }, this)).fail(function () {
            //error();
        });
    },
    squareTakeoff: function () {
        new PJQ.views.projects.SquareTakeoffModal();
    },
    eTakeoff: function () {
        new PJQ.views.projects.eTakeoffModal({
            contact: PJQ.app.session.contact,
            project: PJQ.app.session.project,
            accessKey: PJQ.app.session.get('accessKey')
        });
    },
    submitBidMessage: function () {
        let messageTypeId = this.$('.btn-submit-bid').data('messageTypeId');
        if (messageTypeId > 0) {
            new PJQ.views.projects.UserMessageModal({
                project: this.model,
                userMessageTypeId: messageTypeId,
                onSend: _.bind(function () {
                    if (PJQ.app.session.project.hasPermission('privateMessaging.canView') &&
                        !(PJQ.app.session.project.get('status') === 'ARCHIVE'
                            || PJQ.app.session.project.get('status') === 'NEW'
                            || (PJQ.app.session.user === null && PJQ.app.session.contact === null)
                            || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_PRIVATE_MESSAGES))) {
                        PJQ.app.router.navigate('projects/' + PJQ.app.session.project.id + '/privatemessaging/view/sent', {
                            trigger: true
                        });
                    }
                    PJQ.notifications.notify.successNotify({
                        message: 'Bid Submitted successfully.'
                    });
                }, this)
            });
        }
    }
});

PJQ.views.projects.dashboard.ProjectDetails = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Details-Dashboard')
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {

    }
});

PJQ.views.projects.dashboard.ProjectContactDetails = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Contact-Details-Dashboard')
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {

    }
});

PJQ.views.projects.dashboard.ProjectProposals = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Proposals')
    },
    events: {
        // 'click .group-status-close': 'onClose'
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        };
    },
    afterRender: function () {

    }
});

// Newsfeed
PJQ.views.projects.dashboard.Newsfeed = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Newsfeed'),
        subTemplates: {
            newsfeedItems: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Newsfeed-Items')
        },
        pageNumber: 1,
        pageSize: 10
    },
    events: {
        'click .btn-project-newsfeed-refresh': 'refreshNewsfeed',
        'click .btn-project-newsfeed-view-message-participants': 'viewMessageParticipants',
        'click .btn-project-newsfeed-view-attachments': 'viewAttachments',
        'click .btn-project-newsfeed-copy-message': 'copyMessage',
        'click .btn-project-newsfeed-delete-message': 'deleteMessage'
    },
    beforeFirstRender: function () {

    },
    beforeRender: function () {

    },
    afterRender: function () {
        this.getNewsfeed(this.options.pageNumber);
    },
    refreshNewsfeed: function () {
        this.options.pageNumber = 1;
        this.$('.project-newsfeed-items').html('');
        this.getNewsfeed(this.options.pageNumber);
    },
    getNewsfeed: function (pageNumber) {
        let loader = new PJQ.Loader(this.$('.project-newsfeed-items'));
        this.data = [];
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'newsfeed'
                },
            ], [
                {
                    parameter: 'pageNumber',
                    value: pageNumber
                },
                {
                    parameter: 'pageSize',
                    value: 9999
                }
            ])
        }).get().done(_.bind(function (data) {
            this.data = data;
            loader.remove();
            this.renderSubTemplate(true, this.options.subTemplates.newsfeedItems, this.$('.project-newsfeed-items'), {
                items: data,
                isAdmin: (PJQ.app.session.get('masterUserId') === this.options.project.get('masterUserId'))
            });
        }, this));
    },
    viewAttachments: function (e) {
        let projectMessageId = parseInt(this.$(e.currentTarget).data('projectMessageId'));
        _.each(this.data, _.bind(function (item) {
            if (item.auditAction === 'ProjectMessage' && item.projectMessage && item.projectMessage.projectMessageId === projectMessageId) {
                new PJQ.views.projects.dashboard.ViewMessageAttachmentsModal({
                    attachments: item.attachments
                });
            }
        }, this));
    },
    viewMessageParticipants: function (e) {
        let projectMessageId = parseInt(this.$(e.currentTarget).data('projectMessageId'));
        PJQ.app.router.navigate('projects/' + this.options.project.id + (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW) ? '/messagingnew/' : '/messaging/') + projectMessageId, {
            trigger: true
        });
    },
    copyMessage: function (e) {
        let projectMessageId = parseInt(this.$(e.currentTarget).data('projectMessageId'));
        PJQ.app.router.navigate('projects/' + this.options.project.id + (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW) ? '/messagingnew/' : '/messaging/') + projectMessageId + '/copy', {
            trigger: true
        });
    },
    deleteMessage: function (e) {
        let auditLogId = parseInt(this.$(e.currentTarget).data('auditLogId'));
        new PJQ.views.BaseModal({
            header: 'Confirm Delete',
            body: '<div class="text-dark fs-14">Are you sure you want to delete this message and recipient responses?</div>',
            okButtonText: 'Yes',
            onOk: _.bind(function () {
                if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW)) {
                    let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'projects',
                            value: PJQ.app.session.project.id
                        },
                        {
                            endpoint: 'projectmessages',
                            value: parseInt(this.$(e.currentTarget).data('projectMessageId'))
                        }
                    ]);
                    new PJQ.ajax.Request({
                        endpoint: endpoint
                    }).delete().done(_.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Message deleted successfully.'
                        });
                        this.refreshNewsfeed();
                    }, this)).fail(function () {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Something went wrong!'
                        });
                    });

                } else {
                    selectedCommentId = auditLogId;
                    DeleteProjectMessageByCommentId(_.bind(function () {
                        this.refreshNewsfeed();
                    }, this));
                }
            }, this),
            isShowCancelButton: true,
            cancelButtonText: "No"
        });
    }
});

// Admin Project Stats
PJQ.views.projects.dashboard.ProjectStats = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Stats'),
        subTemplates: {
            statItem: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Stats-Item')
        },
        emptyCallback: null
    },
    events: {},
    beforeFirstRender: function () {

    },
    beforeRender: function () {

    },
    afterRender: function () {
        this.getProjectStats();
    },
    getProjectStats: function () {
        let loader = new PJQ.Loader(this.$('.project-stats-items'));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'stats'
                },
            ])
        }).get().done(_.bind(function (data) {
            loader.remove();

            if (data == null || _.size(data.projectStats) === 0) {
                if (typeof this.options.emptyCallback === 'function') {
                    this.options.emptyCallback();
                    return;
                }
            }

            _.each(data.projectStats, _.bind(function (stats) {
                let labels = [],
                    graphSet = {
                        data: [],
                        backgroundColor: []
                    };
                _.each(stats.datasets, function (dataset) {
                    labels.push(PJQ.helpers.formatHelpers.upperCaseFirstLetterEachWord(dataset.label));
                    graphSet.data.push(dataset.count);
                    graphSet.backgroundColor.push(dataset.color);
                });

                this.renderSubTemplate(true, this.options.subTemplates.statItem, this.$('.project-stats-items'), {
                    stats: stats
                }, _.bind(function ($chart) {
                    new PJQ.charts.Chart($chart.find('.project-stat-chart'), {
                        type: 'doughnut',
                        height: 150,
                        width: 150,
                        showTotal: true,
                        total: stats.total,
                        data: {
                            labels: labels,
                            datasets: [
                                graphSet
                            ]
                        },
                        options: {
                            cutoutPercentage: 70,
                            legend: {
                                display: false
                            }
                        },
                        onClick: _.bind(function (clickedSegments) {
                            if (_.size(clickedSegments) > 0) {
                                let segment = clickedSegments[0],
                                    stat = stats.datasets[segment._index];
                                PJQ.app.router.navigate('projects/' + this.options.project.id + '/' + stat.route, {
                                    trigger: true
                                });
                            }
                        }, this)
                    });
                }, this));
            }, this));

        }, this));
    }
});

PJQ.views.projects.dashboard.ProjectInviteHeader = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Invite-Header'),
    },
    events: {
        'click .send-user-message': 'sendUserMessage'
    },
    beforeFirstRender: function () {
        if (this.options.project != null) {
            this.options.project.getCompanyLogoUrl(_.bind(function () {
                this.render();
            }, this));
            return false;
        }
    },
    beforeRender: function () {
        this.renderData = {
            options: this.options,
            hideBidsDue: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_HIDE_BIDS_DUE)
        }
    },
    afterRender: function () {
        if (PJQ.app.session.contact != null) {
            let projectResponseButtons = [];
            _.each(this.options.project.getProjectStatusList(), _.bind(function (status, index) {
                let colorClass = 'info';
                if (index === 0)
                    colorClass = 'success';
                else if (index === 1)
                    colorClass = 'danger';

                if (status[1]) {
                    projectResponseButtons.push({label: status[0], value: status[0], colorClass: colorClass});
                }
            }, this));

            _.each(this.options.project.userMessageTypes.models, _.bind(function (type) {
                if (type.get('isAlwaysVisible')) {
                    this.$('.user-messages').removeClass('hidden');
                }
            }, this));
        }
    },
    sendUserMessage: function (e) {
        new PJQ.views.projects.UserMessageModal({
            project: this.options.project,
            userMessageTypeId: this.$(e.currentTarget).data('userMessageTypeId'),
            onSend: _.bind(function () {
                this.refresh();
            }, this)
        });
    }
});

// Sub Project Messages
PJQ.views.projects.dashboard.ProjectMessagesSub = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Messages-Sub'),
        subTemplates: {
            messageItems: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Messages-Sub-Items')
        }
    },
    events: {
        'click .project-message>.card-header': 'stopPropagationIfSelected',
        'click .project-message .btn-download-attachment': 'downloadAttachment',
        'shown.bs.collapse .project-message .collapse': 'messageShown'
    },
    beforeFirstRender: function () {
        this.options.project.fetchProjectMessageResponses(_.bind(function (responses) {
            this.model = responses;
            this.render();
        }, this));
    },
    afterRender: function () {
        if (this.model && this.model.isFetched) {
            let projectStatuses = this.options.project.getProjectStatusList();
            this.renderSubTemplate(true, this.options.subTemplates.messageItems, this.$('.project-message-items'), {
                model: this.model,
                projectStatuses: projectStatuses
            }, _.bind(function () {
                this.projectResponseButtons = [];
                _.each(projectStatuses, _.bind(function (status, index) {
                    let colorClass = 'info';
                    if (index === 0) {
                        colorClass = 'success';
                    } else if (index === 1) {
                        colorClass = 'danger';
                    }
                    if (status[1]) {
                        this.projectResponseButtons.push({
                            label: status[0],
                            value: status[0],
                            colorClass: colorClass
                        });
                    }
                }, this));

                this.messageResponseButtons = [];
                _.each(this.options.project.getMessageStatusList(), _.bind(function (status, index) {
                    let colorClass = 'info';
                    if (index === 0)
                        colorClass = 'success';
                    else if (index === 1)
                        colorClass = 'danger';

                    if (status[1]) {
                        this.messageResponseButtons.push({
                            label: status[0],
                            value: status[0],
                            colorClass: colorClass
                        });
                    }
                }, this));
                if (_.size(this.model.messages.models) > 0) {
                    _.each(this.model.messages.models, function (model) {
                        this.renderMessageResponseButton(model);
                    }, this);

                    // try to open the message matching the key they came in with
                    let contextMessage = this.model.getContextMessage();
                    contextMessage = this.setContextMessage(contextMessage);
                    if (contextMessage != null) {
                        this.$('#project-messages-sub-' + contextMessage.get('accessKey')).collapse('show');

                        let urlStatus = PJQ.app.session.get('bidStatus');
                        if (_.size(urlStatus) > 0) {
                            PJQ.app.session.set('bidStatus', null);
                            // make sure the status in the url was a valid status
                            let actualStatus = _.find(_.union(PJQ.app.session.project.getProjectStatusList(), [['YES', true], ['NO', true]]), function (status) {
                                return status[0].toUpperCase() === urlStatus.toUpperCase();
                            });
                            if (actualStatus != null) {
                                this.handleResponse(contextMessage, actualStatus[0]);
                                this.render();
                            }
                        }
                    }
                } else {
                    this.renderContextMessageResponseButton();
                }

                this.$('#projectMessagesSubAccordion').on('shown.bs.collapse', function () {
                    $(this).parent().find(".card-header[aria-expanded='true'] .fa-chevron-down").removeClass("fa-chevron-down").addClass("fa-chevron-right");
                    $(this).parent().find(".card-header[aria-expanded='false'] .fa-chevron-right").removeClass("fa-chevron-right").addClass("fa-chevron-down");
                });
            }, this));
        } else {
            new PJQ.Loader(this.$('.project-message-items'));
        }
    },
    setContextMessage: function (selectedMessage) {
        let contextMessage = null;
        if (selectedMessage != null && selectedMessage.canChangeStatus()) {
            contextMessage = selectedMessage;
        }

        if (contextMessage == null) {
            let noResponseMessages = this.model.messages.getChangeableMessages();
            if (_.size(noResponseMessages) > 0) {
                contextMessage = _.max(noResponseMessages, function (item) {
                    return PJQ.helpers.dateHelpers.getDateDiff(new Date(), new Date(item.get('createdOn')));
                });
            }
        }

        if (contextMessage == null) {
            if (_.size(this.model.messages) > 0) {
                contextMessage = _.max(this.model.messages.models, function (item) {
                    return PJQ.helpers.dateHelpers.getDateDiff(new Date(), new Date(item.get('createdOn')));
                });
            }
        }

        this.renderContextMessageResponseButton(contextMessage);

        return contextMessage;
    },
    getMessageElement: function (message) {
        return $('div.card[data-access-key="' + message.get('accessKey') + '"]');
    },
    messageShown: function (e) {
        let accessKey = $(e.currentTarget).data('accessKey').toString(),
            selectedMessage = this.model.messages.findWhere({accessKey: accessKey.toUpperCase()});
        this.setContextMessage(selectedMessage);
    },
    handleResponse: function (message, response) {
        // if they have more than one group, collect responses per group
        let messageType = message.get('type');

        // 2023-08-14 do not check the message type anymore, since bid reminders get sent with no message type but have response buttons in them
        //if (messageType === 'PROJECT' || messageType === 'MESSAGE') {
            message.set('status', response);
        //}

        if (messageType != 'MESSAGE' && this.model.contactGroups.models.length > 1) {
            new PJQ.views.projects.dashboard.GetGroupResponsesSubModal({
                contactGroups: this.model.contactGroups,
                accessKey: message.get('accessKey'),
                onSave: _.bind(function (result) {
                    // todo: update project contact accordingly so that other views can process the change
                    if (message.responseButton)
                        message.responseButton.setValue(result.response);

                    if (this.contextResponseControl)
                        this.contextResponseControl.setValue(result.response);

                    PJQ.notifications.notify.successNotify({
                        message: 'Your response of ' + result.response + ' has been recorded.'
                    });
                    this.checkDeclinedResponseQuestion(result.response, message.get('accessKey'));
                }, this)
            });
        } else {
            // just save the overall response
            let contactGroups = new PJQ.collections.projectMessages.ProjectContactGroups(),
                contactGroup = new PJQ.models.projectMessages.ProjectContactGroup();

            contactGroup.set('groupStatus', response);
            contactGroups.add(contactGroup);
            contactGroups.accessKey = message.get('accessKey');

            contactGroups.save({
                success: _.bind(function (result) {
                    if (this.contextResponseControl != null) {
                        this.contextResponseControl.setValue(result.response);
                    }

                    PJQ.notifications.notify.successNotify({
                        message: 'Your response of ' + result.response + ' has been recorded.'
                    });

                    if (messageType != 'MESSAGE')
                        this.checkDeclinedResponseQuestion(result.response, message.get('accessKey'));
                }, this)
            });
        }
    },
    checkDeclinedResponseQuestion: function(response, accessKey) {
        if (!PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_MESSAGE_DECLINE_QUESTION))
            return;

        PJQ.app.session.project.getProjectStatuses(_.bind(function(statuses) {
            if (response === statuses[1].name) {
                let declineQuestionSettings = new PJQ.models.projectParticipants.ProjectMessageDeclineQuestionSettings(null, {
                    project: PJQ.app.session.project
                });

                declineQuestionSettings.fetch({
                    success: _.bind(function() {

                        let projectLocation = '';
                        if (PJQ.app.session.project.get('city'))
                            projectLocation = PJQ.app.session.project.get('city');
                        if (PJQ.app.session.project.get('state'))
                            projectLocation += (PJQ.app.session.project.get('city') ? ', ' : '') + PJQ.app.session.project.get('state');
                        if (PJQ.app.session.project.get('zip'))
                            projectLocation += (_.size(projectLocation)>0 ? ' ' : '') + PJQ.app.session.project.get('zip');

                        if (_.size(projectLocation) == 0)
                            projectLocation = "N/A";

                        let recipientGroups = _.map(this.model.contactGroups.models, function(contactGroup) {
                            return contactGroup.get('groupName');
                        });

                        let companyName =  _.size(PJQ.app.session.project.user.get('companyName')) > 0 ? PJQ.app.session.project.user.get('companyName') : PJQ.app.session.project.user.get('contactName');

                        let questions = _.map(declineQuestionSettings.get('questions'), _.bind(function(question) {
                            question = question.replace(/\[Project.Location\]/g, projectLocation);
                            question = question.replace(/\[ProjectMessage.RecipientGroupListComma\]/g, recipientGroups.join(', '));
                            question = question.replace(/\[Sender.CompanyName\]/g, companyName);

                            return question;

                        }, this));

                        new PJQ.views.projects.dashboard.ProjectMessageDeclineQuestionModal({
                            questions: questions,
                            accessKey: accessKey,
                            response: response
                        });

                    }, this)
                });
            }
        }, this));
    },
    renderMessageResponseButton: function (message) {
        if (message.canChangeStatus()) {
            message.responseButton = new PJQ.inputs.ButtonGroup({
                el: this.getMessageElement(message).find('.message-responses'),
                colorInactiveButtons: true,
                buttonClasses: 'font-weight-bold',
                separateButtons: true,
                buttons: message.get('type') === 'PROJECT' ? this.projectResponseButtons : this.messageResponseButtons,
                defaultValue: (_.size(message.get('status')) > 0 && message.get('status') !== 'PENDING') ? message.get('status') : null,
                onChange: _.bind(function (value) {
                    if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DOWNLOAD_CONTACT_UPDATE_REQ) && PJQ.app.session.contact.get('updatedOn') == null) {
                        new PJQ.views.contacts.BaseEditContactModal({
                            alert: "You must update your contact information before Responding.",
                            onSave: _.bind(function () {
                                PJQ.app.session.contact.set('updatedOn', new Date());
                                this.contextResponseControl.setValue(value);
                                this.handleResponse(message, value);
                            }, this),
                            model: new PJQ.models.projectContacts.ProjectContact({
                                id: PJQ.app.session.contact.id,
                                projectId: PJQ.app.session.project.id
                            })
                        });
                    } else {
                        this.contextResponseControl.setValue(value);
                        this.handleResponse(message, value);
                    }
                }, this)
            });
        }
    },
    renderContextMessageResponseButton: function (message) {
        if (this.contextResponseControl != null) {
            this.contextResponseControl.remove();
        }
        if (message != null && message.canChangeStatus()) {
            this.contextResponseControl = new PJQ.inputs.ButtonGroup({
                el: this.options.dashboard.inviteHeader.$('.responses-control'),
                colorInactiveButtons: true,
                buttonClasses: 'font-weight-bold',
                separateButtons: true,
                buttons: message.get('type') === 'PROJECT' ? this.projectResponseButtons : this.messageResponseButtons,
                defaultValue: (_.size(message.get('status')) > 0 && message.get('status') !== 'PENDING') ? message.get('status') : null,
                onChange: _.bind(function (value) {
                    if (message.responseButton != null) {
                        message.responseButton.setValue(value, true);
                    }
                }, this)
            });
        } else if (this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SUB_RESPONSE) && message && message.canChangeStatus()) {
            this.contextResponseControl = new PJQ.inputs.ButtonGroup({
                el: this.options.dashboard.inviteHeader.$('.responses-control'),
                colorInactiveButtons: true,
                buttonClasses: 'font-weight-bold',
                separateButtons: true,
                buttons: this.projectResponseButtons,
                defaultValue: (_.size(this.options.project.get('bidResponse')) > 0 && this.options.project.get('bidResponse') !== 'PENDING') ? this.options.project.get('bidResponse') : null,
                onChange: _.bind(function (value) {
                    this.options.project.updateResponse(value, _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Your response of ' + value + ' has been recorded.'
                        });
                        this.checkDeclinedResponseQuestion(value, message.get('accessKey'));
                    }, this));
                }, this)
            });
        } else {
            this.options.dashboard.inviteHeader.$('.response-header').addClass('hidden');
        }
    },
    stopPropagationIfSelected: function (e) {
        if ($(e.currentTarget).attr('aria-expanded') === 'true')
            e.stopPropagation();
    },
    downloadAttachment: function (e) {
        let accessKey = $(e.currentTarget).closest('.collapse').data('accessKey').toString(),
            cid = $(e.currentTarget).data('cid'),
            message = this.model.messages.findWhere({accessKey: accessKey.toUpperCase()});

        let attachment = message.attachments.get(cid);
        this.options.project.downloadAttachments(attachment);
    }
});

PJQ.views.projects.dashboard.GetGroupResponsesSubModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Contact-Group-Status-Sub'),
        minWidth: '50%',
        onSave: _.noop,
        contactGroups: null
    },
    events: {
        'click .group-status-close': 'onClose',
        'click .group-status-save': 'onSave'
    },
    beforeRender: function () {
        this.renderData = {
            groups: this.options.contactGroups.models
        };
    },
    afterRender: function () {
        this.projectResponseButtons = [];
        _.each(PJQ.app.session.project.getProjectStatusList(), _.bind(function (status, index) {
            let colorClass = 'info';
            if (index === 0) {
                colorClass = 'success';
            } else if (index === 1) {
                colorClass = 'danger';
            }
            if (status[1]) {
                this.projectResponseButtons.push({
                    label: status[0],
                    value: status[0],
                    colorClass: colorClass
                });
            }
        }, this));

        this.globalResponse = new PJQ.inputs.ButtonGroup({
            el: this.$('.global-response'),
            colorInactiveButtons: true,
            buttons: this.projectResponseButtons,
            defaultValue: null,
            onChange: _.bind(function (value) {
                _.each(this.options.contactGroups.models, _.bind(function (group) {
                    group.groupResponse.setValue(value);
                    group.set('groupStatus', value);
                    this.setSaveButton();
                }, this));
            }, this)
        });

        _.each(this.options.contactGroups.models, _.bind(function (group) {
            group.groupResponse = new PJQ.inputs.ButtonGroup({
                el: this.getGroupElement(group).find('.group-response'),
                colorInactiveButtons: true,
                buttons: this.projectResponseButtons,
                defaultValue: null,
                onChange: _.bind(function (value) {
                    group.set('groupStatus', value);
                    this.setSaveButton();
                }, this)
            });
        }, this));
    },
    getGroupElement: function (group) {
        return $('div.group-response-container[data-group-id="' + group.get('groupId') + '"]');
    },
    setSaveButton: function () {
        this.$('.group-status-save').attr('disabled', false);
        _.each(this.options.contactGroups.models, _.bind(function (group) {
            if (_.size(group.groupResponse.getValue()) === 0)
                this.$('.group-status-save').attr('disabled', true);
        }, this));

    },
    onClose: function () {
        this.removeModal();
    },
    onSave: function () {
        this.options.contactGroups.accessKey = this.options.accessKey;
        this.options.contactGroups.save({
            success: _.bind(function (result) {

                if (typeof this.options.onSave === 'function')
                    this.options.onSave(result);

                this.removeModal();

            }, this)
        });
    }
});

PJQ.views.projects.DownloadTermsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Download-Terms'),
        maxWidth: '600px',
        minHeight: '500px',
        onAccept: null
    },
    events: {
        'click .terms-accept': 'onAcceptClicked',
    },
    renderData: function () {
        return {
            project: this.options.project
        };
    },
    onAcceptClicked: function () {
        this.options.project.set('downloadTermsAgreed', true);
        if (typeof this.options.onAccept === 'function') {
            this.options.onAccept();
        }

        if (this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.DOWNLOAD_TERMS_SIGNATURE_REQ)) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: this.options.project.id
                    },
                    {
                        endpoint: 'downloadterms'
                    },
                    {
                        endpoint: 'sign'
                    }
                ]),
                data: {
                    companyName: this.$('.input-terms-company-name').val(),
                    contactName: this.$('.input-terms-contact-name').val(),
                    title: this.$('.input-terms-title').val(),
                    email: this.$('.input-terms-email').val()
                },
            }).put();
        }
        this.removeModal();
    }
});

PJQ.views.projects.ProjectMessageResponseModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Project-Message-Response'),
        maxWidth: '600px',
        minHeight: '500px',
        onResponse: null
    },
    afterRender: function () {
        let projectResponseButtons = [];
        _.each(this.options.project.getProjectStatusList(), _.bind(function (status, index) {
            let colorClass = 'info';
            if (index === 0)
                colorClass = 'success';
            else if (index === 1)
                colorClass = 'danger';

            if (status[1]) {
                projectResponseButtons.push({label: status[0], value: status[0], colorClass: colorClass});
            }
        }, this));
        this.contextResponseControl = new PJQ.inputs.ButtonGroup({
            el: this.$('.responses-control'),
            colorInactiveButtons: true,
            buttonClasses: 'font-weight-bold',
            separateButtons: true,
            buttons: projectResponseButtons,
            defaultValue: (_.size(this.options.project.get('bidResponse')) > 0 && this.options.project.get('bidResponse') !== 'PENDING') ? this.options.project.get('bidResponse') : null,
            onChange: _.bind(function (value) {
                this.options.project.updateResponse(value, _.bind(function () {
                    if (typeof this.options.onResponse === 'function') {
                        this.options.onResponse(value);
                    }
                    this.removeModal();
                }, this));
            }, this)
        });
    }
});

PJQ.views.projects.SquareTakeoffModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Square-Takeoff'),
        maxWidth: '600px'
    },
    events: {
        'click .square-video': 'watchVideo',
        'click .square-login': 'login',
        'click .square-register': 'register'
    },
    watchVideo: function () {
        window.open('https://www.squaretakeoff.com/ref?id=6-video&url=https://squaretakeoff.com/pantera', '_blank');
    },
    login: function () {
        window.open('https://www.squaretakeoff.com/ref?id=5-login&url=https://app.squaretakeoff.com', '_blank');
    },
    register: function () {
        window.open('https://www.squaretakeoff.com/ref?id=7-register&url=https://squaretakeoff.com/sign-up', '_blank');
    }
});

PJQ.views.projects.eTakeoffModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-eTakeoff'),
        maxWidth: '600px'
    },
    events: {
        'click .etakeoff-download': 'download',
        'click .etakeoff-launch': 'launch'
    },
    download: function () {
        window.open('http://etakeoff.com/product/download/?partner_name=Pantera&gc_name=' + (this.options.contact ? encodeURIComponent(this.options.contact.get('companyName')) : ''), '_blank');
    },
    launch: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'accesskey',
                value: this.options.accessKey
            },
            {
                endpoint: 'etakeoff'
            }
        ]));
    }
});

// Project Attachments
PJQ.views.projects.ProjectAttachments = PJQ.views.projects.Attachments.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Dashboard-Attachments'),
        subTemplates: {
            attachment: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Dashboard-Attachment')
        },
        folderColors: [
            '#b7a1e0',
            '#80bdff'
        ],
        isHideDrawings: false,
        isHideDownload: false,
        isHideFiles: false,
        isHideEmptyFolders: false,
        isHidePrivate: true,
        onChange: _.noop,
        selectedAttachments: null,
        preventSelectAll: false,
        foldersOnly: false,
        canOrder: false
    },
    events: {
        'change .input-select-attachment': 'attachmentChecked',
        'click .attachment .pretty': 'stopPropagation',
        'click .attachment': 'attachmentClicked',
        'click .btn-order-selected': 'orderPrints',
        'click .btn-download-attachment': 'downloadAttachment',
        'click .btn-download-selected': 'downloadSelected',
        'click .btn-download-all': 'downloadAll',
        'click .btn-download-all-flattened': 'downloadAllFlattened',
        'click .btn-download-all-combined': 'downloadAllCombined',
        'click .btn-view-attachment': 'viewAttachment'
    },
    beforeFirstRender: function () {
        let prefs = this.options.project.preferences;
        if (prefs && prefs.hasPref(PJQ.constants.preferenceTypes.EXPAND_PROJECT_ATTACHMENTS)) {
            this.options.expandAllFolders = true;
        }

        this.options.enableDrawings = !this.options.isHideDrawings && !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DRAWINGS);

        this.options.foldersOnly = this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.RSVP_FOLDER_CHECKBOXES_ONLY) &&
            this.options.project.get('masterUserId') !== PJQ.app.session.get('masterUserId');

        this.selectedAttachments = this.options.selectedAttachments !== null ? this.options.selectedAttachments : new PJQ.collections.projects.ProjectAttachments(null, {
            project: this.options.project
        });

        let sfOverride = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_SHARED_FOLDER_NAME_OVERRIDE);
        if (_.size(sfOverride) > 0) {
            this.options.sharedFolderNameOverride = sfOverride;
        }

        if (this.collection == null) {
            this.fetchAttachments({isPrivate: !this.options.isHidePrivate});
        }

        this.options.canOrder = !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_ORDER_PRINT);
    },
    renderData: function () {
        return {
            project: this.options.project,
            collection: this.collection,
            isHideDownload: this.options.isHideDownload,
            isHideFiles: this.options.isHideFiles,
            canOrder: this.options.canOrder,
            versions: this.versions,
            enableDrawings: this.options.enableDrawings,
            isFetched: this.isFetched(),
            isDeferred: this.options.isDeferred
        };
    },
    afterRender: function () {
        if (this.isFetched()) {
            this.renderAttachments();
            if (!this.options.isHideDownload)
                new PJQ.menus.ContextMenu({
                    el: this.$('.attachments-container'),
                    selector: '.attachment',
                    actions: [
                        {
                            name: 'Download',
                            onClick: _.bind(function (attachment) {
                                this.downloadAttachments(attachment);
                            }, this)
                        }
                    ],
                    fetchElementData: _.bind(function (element) {
                        return this.collection.get($(element).data('cid'));
                    }, this),
                    onOpen: _.bind(function (attachment) {
                        this.getAttachmentElement(attachment).addClass('context-attachment');
                    }, this),
                    onClose: _.bind(function () {
                        this.$('.context-attachment').removeClass('context-attachment');
                    }, this)
                });
        }
    },
    renderAttachments: function () {
        let $container = this.$('.attachments-container');
        _.each(this.sortAttachments(this.collection.getRootSharedAttachments()), function (attachment) {
            if (!this.options.isDeferred && ((this.options.isHideFiles && !attachment.get('isFolder')) || (this.options.isHideEmptyFolders && attachment.get('isFolder') && _.size(attachment.getFolderAttachments(true)) === 0))) {
                return;
            }
            this.renderAttachment($container, attachment);
        }, this);
        if (!this.options.preventSelectAll && this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJ_DASHBOARD_SELECT_ALL_ATTACHMENTS)) {
            _.each(this.collection.getRootSharedAttachments(), function (attachment) {
                let $checkbox = this.getAttachmentElement(attachment).find('.input-select-attachment');
                $checkbox.prop('checked', true);
                $checkbox.trigger('change');
            }, this);
        }
    },
    renderAttachment: function ($container, attachment) {
        if (!this.options.isDeferred && this.options.isHideEmptyFolders && attachment.get('isFolder') && _.size(attachment.getFolderAttachments(true)) === 0) {
            return;
        }

        this.renderSubTemplate(true, this.options.subTemplates.attachment, $container, {
            model: attachment,
            isDeferred: this.options.isDeferred,
            foldersOnly: this.options.foldersOnly,
            folderColor: this.options.folderColors[attachment.getDepth() % _.size(this.options.folderColors)],
            isHideFiles: this.options.isHideFiles,
            isExpanded: this.expandedFolders.indexOf(attachment.cid) !== -1,
            isSelected: this.selectedAttachments.get(attachment.cid) != null,
            options: this.options
        }, _.bind(function ($folder) {
            if (_.find(this.selectedAttachments.models, function (item) {
                return item.get('entryId') === attachment.get('entryId');
            }) != null)
                $folder.find('.input-select-attachment').prop('checked', true);
            else if (attachment.get('isFolder') && _.find(this.selectedAttachments.models, function (item) {
                return item.get('entryId') === attachment.get('folderId');
            }) != null) {
                $folder.find('.input-select-attachment').prop('checked', true);
            } else if (attachment.get('isFolder') && _.filter(attachment.getFolderAttachments(false, true), _.bind(function (item) {
                return _.find(this.selectedAttachments.models, function (selectedAttachment) {
                    return item.get('entryId') === selectedAttachment.get('entryId');
                }) === undefined;
            }, this)).length === 0 && _.size(attachment.getFolderAttachments(false, true)) > 0 && _.size(this.selectedAttachments.models) > 0) {
                $folder.find('.input-select-attachment').prop('checked', true);
            }

            if (attachment.get('isFolder')) {
                _.each(this.sortAttachments(_.filter(attachment.getFolderAttachments(), function (attachment) {
                    return attachment.get('isFolder');
                })), function (folderAttachment) {
                    this.renderAttachment($folder.find('.attachment-files').first(), folderAttachment);
                }, this);

                _.each(this.sortAttachments(_.filter(attachment.getFolderAttachments(), function (attachment) {
                    return !attachment.get('isFolder');
                })), function (folderAttachment) {
                    this.renderAttachment($folder.find('.attachment-files').first(), folderAttachment);
                }, this);
            }
        }, this));
    },
    sortAttachments: function (attachments) {
        return attachments.sort(function (a, b) {
            let aso = a.get('sortOrder'),
                bso = b.get('sortOrder');
            return PJQ.helpers.sortHelpers.sortAlphaNum(aso != null ? aso.toString() : a.get('name'), bso != null ? bso.toString() : b.get('name'));
        });
    },
    attachmentClicked: function (e) {
        let $attachment = $(e.currentTarget),
            attachment = this.collection.get($attachment.data('cid'));
        if (attachment.get('isFolder')) {
            this.expandFolder($attachment);

            let $attachments = $attachment.siblings('.attachment-files-outer');
            if (!$attachments.is(':visible')) {
                $attachment.css({
                    background: 'rgb(218, 218, 218)'
                });
            } else {
                $attachment.css({
                    background: ''
                });
            }
        } else {
            $attachment.find('.input-select-attachment').trigger('click');
        }
    },
    attachmentChecked: function (e) {
        let $checkbox = $(e.currentTarget),
            $attachment = $checkbox.closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid')),
            isChecked = $checkbox.prop('checked');

        if (attachment.get('isFolder')) {
            let folderAttachments = attachment.getFolderAttachments(true, this.options.isHideFiles);

            // if we're operating at folder level add this folder to selection
            if (this.options.isHideFiles) {
                if (isChecked) {
                    this.addSelectedAttachments([attachment]);
                } else {

                    // if we are not included, and the parent was, we need to remove it and include all our siblings.
                    let parentFolder = attachment.getParentFolder();
                    if (this.selectedAttachments.contains(parentFolder)) {
                        _.each(parentFolder.getFolderAttachments(false, true), _.bind(function (folder) {
                            this.selectedAttachments.add(folder);
                        }, this));
                    }
                    this.removeSelectedAttachments([attachment]);
                }

                // we are either adding this parent (thus including all children), or removing this parent.  Either way the children do not need to be included.
                this.removeSelectedChildAttachmentsRecursive(attachment);

            } else {
                let allAtt = _.union(folderAttachments, [attachment]);
                if (isChecked) {
                    this.addSelectedAttachments(allAtt);
                } else {
                    this.removeSelectedAttachments(allAtt);
                }
            }

            let $folderAttachments = $checkbox.closest('.attachment').siblings('.attachment-files-outer');
            $folderAttachments.find('.input-select-attachment').prop('checked', isChecked);
        } else if (!this.options.isHideFiles) {
            if (isChecked) {
                this.addSelectedAttachments([attachment]);
            } else {
                this.removeSelectedAttachments([attachment]);
            }
        }

        this.setParentCheckbox(attachment);

        this.renderSelectedButton();
    },
    addSelectedAttachments: function (attachments) {
        this.selectedAttachments.add(attachments);

        if (typeof this.options.onChange === 'function')
            this.options.onChange(this.selectedAttachments);

        $('.print-alert').removeClass('hidden');
    },
    removeSelectedAttachments: function (attachments) {
        this.selectedAttachments.remove(attachments);

        if (this.options.isHideFiles) {
            _.each(attachments, _.bind(function (attachment) {
                this.removeSelectedParentFolderRecursive(attachment);
            }, this));
        }

        if (typeof this.options.onChange === 'function')
            this.options.onChange(this.selectedAttachments);
    },
    removeSelectedChildAttachmentsRecursive: function (folder) {
        let attachments = folder.getFolderAttachments();
        _.each(attachments, _.bind(function (attachment) {
            if (attachment.get('isFolder')) {
                this.removeSelectedAttachments(attachment);
                this.removeSelectedChildAttachmentsRecursive(attachment);
            }
        }, this));
    },
    removeSelectedParentFolderRecursive: function (attachment) {
        if (typeof attachment.getParentFolder !== 'function')
            return;

        let folder = attachment.getParentFolder();
        if (folder != null && folder.id > 0) {
            this.selectedAttachments.remove(folder);
            this.removeSelectedParentFolderRecursive(folder);
        }
    },
    renderSelectedButton: function () {
        let selectedCount = _.size(_.filter(this.selectedAttachments.models, function (att) {
            return !this.options.isHideEmptyFolders || !att.get('isFolder');
        }, this));
        this.$('.btn-download-selected').prop('disabled', !(selectedCount > 0));

        if (!this.options.isDeferred) {
            this.$('.ct-selected-attachments').text(selectedCount);
        }
    },
    setParentCheckbox: function (attachment) {
        let folder = attachment.getParentFolder();
        if (folder != null && folder.id > 0) {
            let hasUnselectedAttachments = this.folderHasUnselectedAttachments(folder);
            this.getAttachmentElement(folder).find('.input-select-attachment').prop('checked', !hasUnselectedAttachments);

            //set the checkbox for this folder's parent
            //recursive until there are no more parent folders
            this.setParentCheckbox(folder);
        }
    },
    folderHasUnselectedAttachments: function (folder) {
        let folderAttachments = folder.getFolderAttachments();
        return _.find(folderAttachments, function (folderAttachment) {
            if (folderAttachment.get('isFolder')) {
                if (!this.options.isHideFiles)
                    return this.folderHasUnselectedAttachments(folderAttachment);
                else
                    return this.selectedAttachments.get(folderAttachment.id) == null;
            } else {
                return this.selectedAttachments.get(folderAttachment.id) == null && !this.options.isHideFiles;
            }
        }, this) != null;
    },
    getAttachmentElement: function (attachment) {
        return this.$(".attachment[data-cid='" + attachment.cid + "']");
    },
    downloadAttachment: function (e) {
        e.stopPropagation();
        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        this.options.project.checkDownloadRequirements(_.bind(function () {
            this.downloadAttachments(attachment);
        }, this));
    },
    downloadSelected: function () {
        if (_.size(this.selectedAttachments) > 0) {
            this.options.project.checkDownloadRequirements(_.bind(function () {
                this.downloadAttachments(this.selectedAttachments);
            }, this));
        }
    },
    downloadAllCombined: function () {
        this.downloadAll({
            raster: true,
            merge: true
        })
    },
    downloadAllFlattened: function () {
        this.downloadAll({
            raster: true
        });
    },
    downloadAll: function (opts = null) {
        if (_.size(this.collection.models) > 0) {
            this.options.project.checkDownloadRequirements(_.bind(function () {
                this.downloadAttachments(this.collection, opts);
            }, this));
        }
    },
    viewAttachment: function (e) {
        e.stopPropagation();

        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        if (attachment.isImage()) {
            PJQ.app.view.renderPhotoViewer({
                model: attachment
            });
        } else if (attachment.canRender()) {
            new PJQ.views.files.FileViewer({
                model: attachment
            });
        }
    },
    orderPrints: function () {
        let callback = _.bind(function () {
            let selectedAttachments = this.selectedAttachments.where({isFolder: false});
            new PJQ.views.files.OrderPrintsModal({
                contact: PJQ.app.session.contact,
                files: selectedAttachments
            });
        }, this);

        if (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === 'busy') {
            new PJQ.views.modals.YesNo({
                header: "Document(s) Processing",
                body: "Please Note: New documents are currently being processed for this project.  Are you sure you want to place an order?",
                onYes: _.bind(function () {
                    callback();
                }, this)
            });
        } else
            callback();
    }
});

PJQ.views.projects.dashboard.BidPackages = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'bid-packages')
    },
    events: {},
    renderData: function () {
        return {
            collection: this.collection
        }
    },
    beforeFirstRender: function () {

    },
    afterRender: function () {

    }
});

PJQ.views.projects.dashboard.ViewMessageAttachmentsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'modal-view-message-attachments'),
        minWidth: '25%',
        attachments: []
    },
    events: {
        'click .btn-download': 'downloadFile',
        'click .btn-download-all': 'downloadAll'
    },
    renderData: function () {
        return {
            attachments: this.options.attachments
        }
    },
    downloadFile: function (e) {
        let url = this.$(e.currentTarget).data('url');
        PJQ.files.downloadFile(url, {
            isEndpoint: false
        });
    },
    downloadAll: function () {
        let entryIds = _.map(this.options.attachments, function (attachment) {
            return attachment.entryId
        });
        PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files'
            },
            {
                endpoint: 'downloadentryidlist'
            }
        ]), {entryList: entryIds});
    }

});

PJQ.views.projects.dashboard.ProjectMessageDeclineQuestionModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'modal-project-message-decline-question'),
        minWidth: '40%'
    },
    events: {
        'click .submit-response': 'submitResponse',
        'change input[type="radio"]': 'responseChanged'
    },
    renderData: function () {
        return {
            questions: this.options.questions,
            response: this.options.response
        }
    },
    responseChanged: function(e) {
        this.$('.submit-response').prop('disabled', false);

        if ($(e.currentTarget).prop('id') === 'question-other') {
            this.$('.other-reason').removeClass('hidden');
            this.$('.other-reason').focus();
        }
        else
            this.$('.other-reason').addClass('hidden');

    },
    submitResponse: function() {
        let $question = this.$('input[type="radio"]:checked'), response = '';

        if ($question.prop('id') === 'question-other') {
            response = 'Other';

            if (_.size(this.$('.other-reason').val()) > 0)
                response += ": " + this.$('.other-reason').val();
        }
        else
            response = this.options.questions[$question.prop('id').substring($question.prop('id').indexOf('-')+1)];

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.get('projectId')
                },
                {
                    endpoint: 'projectmessages'
                },
                {
                    endpoint: 'accesskey',
                    value: this.options.accessKey
                },
                {
                    endpoint: 'response'
                },
                {
                    endpoint: 'reason'
                }
            ]),
            data: {
                reason: response
            }
        }).post().done(_.bind(function (data) {
            PJQ.notifications.notify.successNotify({
                message: 'Response recorded successfully.'
            });
            this.removeModal();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Unable to record response.'
            });
        });

    }
});
